"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPipeOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M15 4a1 1 0 110 2h-1v2h1a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6a2 2 0 012-2h1V6H9a1 1 0 010-2h6zM3 9a1 1 0 011 1v1h2v4H4v1a1 1 0 11-2 0v-6a1 1 0 011-1zm18 0a1 1 0 011 1v6a1 1 0 11-2 0v-1h-2v-4h2v-1a1 1 0 011-1zm-6 1H9v6h6v-6z' }))); };
exports.default = SvgPipeOutline;
//# sourceMappingURL=PipeOutline.js.map